// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import Helmet from "react-helmet"

interface Props {
  type?: string
  username?: string
  title: string
  desc: string
  image: string
}

const defaultProps: Props = {
  type: "summary_large_image",
  username: null,
  title: null,
  desc: null,
  image: null,
}

const Twitter: React.FC<Props> = ({ type, username, title, desc, image }) => (
  <Helmet>
    <meta name="twitter:card" content={type} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={desc} />
    <meta name="twitter:image" content={image} />
    {username && <meta name="twitter:creator" content={username} />}
  </Helmet>
)

Twitter.defaultProps = defaultProps

export default Twitter
